import React, { useEffect } from "react";
import "./ContactUs.css";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaClock } from "react-icons/fa";

const ContactUs = () => {

  // -------- REPEAT SCROLL ANIMATION ----------
  useEffect(() => {
    const cards = document.querySelectorAll(".cu-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("cu-show");
          } else {
            entry.target.classList.remove("cu-show"); // repeat animation
          }
        });
      },
      { threshold: 0.25 }
    );

    cards.forEach((card) => observer.observe(card));
  }, []);

  // -------- ANIMATED PLACEHOLDER EFFECT ----------
  useEffect(() => {
    const animatedFields = document.querySelectorAll(".animate-placeholder");

    animatedFields.forEach((field) => {
      const text = field.getAttribute("data-text");
      let index = 0;
      let reverse = false;

      const typeEffect = setInterval(() => {
        if (!reverse) {
          field.placeholder = text.substring(0, index++);
          if (index === text.length + 1) reverse = true;
        } else {
          field.placeholder = text.substring(0, index--);
          if (index < 0) reverse = false;
        }
      }, 120);

      return () => clearInterval(typeEffect);
    });
  }, []);

  return (
    <div className="cu-wrapper">

      {/* ---------- BEAUTIFUL HEADING ---------- */}
      <section className="cu-hero">
        <h1>Contact Us</h1>
        <p>We’d love to connect — reach out anytime.</p>
      </section>

      {/* ---------- NEW PREMIUM CARDS ---------- */}
      <section className="cu-grid">

        {/* Address */}
        <div className="cu-card">
          <div className="cu-icon"><FaMapMarkerAlt /></div>
          <h3>Head Office</h3>
          <p>
            Office No.202, Mantri House, Fergusson College Rd,<br />
            Shivajinagar, Pune, Maharashtra 411005
          </p>
        </div>

        {/* Email */}
        <div className="cu-card">
          <div className="cu-icon"><FaEnvelope /></div>
          <h3>Email Support</h3>
          <p>info@nmdinfotechservices.com</p>
          <p>hr@nmdinfotechservices.com</p>
        </div>

        {/* Call */}
        <div className="cu-card">
          <div className="cu-icon"><FaPhoneAlt /></div>
          <h3>Let's Talk</h3>
          <p>9049442717</p>
        </div>

        {/* Hours */}
        <div className="cu-card">
          <div className="cu-icon"><FaClock /></div>
          <h3>Office Hours</h3>
          <p>Mon - Sat <br /> 09am - 06pm</p>
        </div>

      </section>

      {/* ================= ENQUIRY + MAP SECTION ================= */}
      <section className="cu-enquiry-sec">

        {/* LEFT – GLASSY ENQUIRY FORM */}
        <div className="cu-enquiry-form">
          <h2>Send Enquiry</h2>

          <form
            action="https://api.web3forms.com/submit"
            method="POST"
          >
            {/* REQUIRED: WEB3FORMS ACCESS KEY */}
            <input
              type="hidden"
              name="access_key"
              value="157f5dfc-898c-4749-aab8-a80e612db795"
            />

            <input
              type="text"
              name="name"
              className="animate-placeholder"
              data-text="Full Name *"
              placeholder=""
              required
            />

            <input
              type="email"
              name="email"
              className="animate-placeholder"
              data-text="Email ID *"
              placeholder=""
              required
            />

            <input
              type="text"
              name="mobile"
              className="animate-placeholder"
              data-text="Mobile Number *"
              placeholder=""
              required
            />

            <textarea
              name="message"
              className="animate-placeholder"
              data-text="Write your message"
              placeholder=""
              required
            ></textarea>

            <button type="submit" className="cu-btn">Submit</button>
          </form>
        </div>

        {/* RIGHT – MAP */}
        <div className="cu-map-box">
          <div className="cu-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.235848035225!2d73.8414203749647!3d18.520430170069243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c068e8ab0b8b%3A0x34f6c18fef114c61!2sMantri%20House%2C%20Fergusson%20College%20Rd%2C%20Shivajinagar%2C%20Pune!5e0!3m2!1sen!2sin!4v1708000000000"
              width="100%"
              height="100%"
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

      </section>

    </div>
  );
};

export default ContactUs;
